<template>
  <section class="search-hero">
    <div class="core-container search-hero__body">
      <form class="search-hero__form" @submit.prevent="handleSearch">
        <input
          v-model="localKeyword"
          type="search"
          class="search-hero__input"
          :placeholder="placeholder"
        />
        <button type="submit" class="search-hero__btn">搜索</button>
      </form>

      <div class="search-hero__industries">
        <span class="search-hero__industries-label">热门行业：</span>
        <div class="search-hero__industries-links">
          <button
            v-for="item in hotIndustries"
            :key="item.label"
            type="button"
            :class="[
              'search-hero__industry',
              { 'is-active': isIndustryActive(item) }
            ]"
            @click="selectIndustry(item)"
          >{{ item.label }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  SEARCH_HERO_PLACEHOLDER,
  SEARCH_HOT_INDUSTRIES,
  parseCategoryFilter,
  patchCategorySelection
} from '@/constants/searchPage'

export default {
  name: 'SearchHero',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    sameNameMulti: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localKeyword: this.keyword,
      placeholder: SEARCH_HERO_PLACEHOLDER,
      hotIndustries: SEARCH_HOT_INDUSTRIES
    }
  },
  watch: {
    keyword(value) {
      this.localKeyword = value
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', {
        keyword: this.localKeyword.trim()
      })
    },
    isIndustryActive(item) {
      if (!item.category) {
        return !parseCategoryFilter(this.category).length
      }
      return parseCategoryFilter(this.category).includes(String(item.category))
    },
    selectIndustry(item) {
      this.$emit('industry-select', {
        category: patchCategorySelection(
          this.category,
          item.category,
          this.sameNameMulti
        )
      })
    }
  }
}
</script>

<style scoped>
.search-hero {
  background: linear-gradient(
    90deg,
    var(--color-banner-fill-left) 0%,
    var(--color-banner-fill-left) 42%,
    var(--color-banner-fill-right) 58%,
    var(--color-banner-fill-right) 100%
  );
}

.search-hero__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
  padding: var(--search-hero-padding-y) 0;
}

.search-hero__form {
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 860px;
}

.search-hero__input {
  flex: 1;
  min-width: 0;
  height: var(--search-bar-height);
  padding: 0 var(--space-md);
  border: none;
  border-radius: var(--radius-sm) 0 0 var(--radius-sm);
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
  outline: none;
}

.search-hero__btn {
  flex-shrink: 0;
  min-width: var(--search-btn-min-width);
  height: var(--search-bar-height);
  padding: 0 var(--space-lg);
  border: none;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  background: var(--color-primary);
  color: var(--color-text-inverse);
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
}

.search-hero__btn:hover {
  background: var(--color-primary-dark);
}

.search-hero__industries {
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 860px;
  line-height: 1.8;
}

.search-hero__industries-label {
  flex-shrink: 0;
  font-size: var(--search-filter-font-size);
  color: var(--color-text-inverse);
  opacity: var(--search-hero-industry-opacity);
}

.search-hero__industries-links {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--search-hero-industry-gap);
}

.search-hero__industry {
  border: none;
  background: transparent;
  font-size: var(--search-filter-font-size);
  color: var(--color-text-inverse);
  opacity: var(--search-hero-industry-opacity);
  line-height: 1.8;
  cursor: pointer;
  padding: 0;
}

.search-hero__industry:hover,
.search-hero__industry.is-active {
  opacity: 1;
  font-weight: 600;
}
</style>
